import React, { ForwardedRef, forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const FilePDF: Icon = forwardRef(
  (
    { color = 'currentColor', size = 24, ...rest },
    ref: ForwardedRef<SVGSVGElement>
  ) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8372 23H6.04651C4.91625 23 4 22.0837 4 20.9535V3.04651C4 1.91625 4.91625 1 6.04651 1H14.8904C15.4504 1 15.9861 1.22955 16.3723 1.63512L20.3192 5.77931C20.6816 6.15984 20.8837 6.6652 20.8837 7.1907V20.9535C20.8837 22.0837 19.9675 23 18.8372 23ZM15.5 6.20001V3.22428C15.5 2.95701 15.8231 2.82316 16.0121 3.01214L18.9879 5.98788C19.1769 6.17687 19.043 6.50001 18.7757 6.50001H15.8C15.6343 6.50001 15.5 6.3657 15.5 6.20001ZM6.4729 12.3472V17H7.41235V15.2449H8.0249C8.4502 15.2449 8.77498 15.2227 8.99927 15.1782C9.16431 15.1423 9.32617 15.0693 9.48486 14.9592C9.64567 14.8471 9.77791 14.6937 9.88159 14.499C9.98527 14.3044 10.0371 14.0642 10.0371 13.7786C10.0371 13.4083 9.94718 13.1068 9.76733 12.874C9.58748 12.6392 9.36426 12.4868 9.09766 12.417C8.92415 12.3705 8.55176 12.3472 7.98047 12.3472H6.4729ZM7.41235 14.4546V13.1343H7.86621C8.20475 13.1343 8.43009 13.1449 8.54224 13.166C8.69458 13.1935 8.82048 13.2623 8.91992 13.3723C9.01937 13.4824 9.06909 13.622 9.06909 13.7913C9.06909 13.9288 9.03312 14.0494 8.96118 14.1531C8.89136 14.2568 8.79403 14.3329 8.66919 14.3816C8.54435 14.4303 8.29679 14.4546 7.92651 14.4546H7.41235ZM12.5222 12.3472H10.8052V17H12.573C12.92 17 13.1972 16.9672 13.4045 16.9016C13.6817 16.8128 13.9018 16.689 14.0647 16.5303C14.2805 16.3208 14.4466 16.0468 14.563 15.7083C14.6582 15.4311 14.7058 15.101 14.7058 14.718C14.7058 14.2822 14.655 13.9161 14.5535 13.6199C14.4519 13.3215 14.3038 13.0698 14.1091 12.8645C13.9145 12.6593 13.6807 12.5165 13.4077 12.436C13.2046 12.3768 12.9094 12.3472 12.5222 12.3472ZM11.7446 16.2161V13.1343H12.1667C12.5497 13.1343 12.8068 13.1491 12.938 13.1787C13.1136 13.2168 13.2585 13.2898 13.3728 13.3977C13.4871 13.5056 13.5759 13.6559 13.6394 13.8484C13.7029 14.0409 13.7346 14.3171 13.7346 14.6768C13.7346 15.0365 13.7029 15.3211 13.6394 15.5305C13.5759 15.7379 13.4934 15.8871 13.3918 15.978C13.2924 16.069 13.1665 16.1336 13.0142 16.1716C12.8978 16.2013 12.7084 16.2161 12.446 16.2161H11.7446ZM15.512 17V12.3472H18.7017V13.1343H16.4514V14.2356H18.3938V15.0227H16.4514V17H15.512Z"
          fill={color}
        />
      </svg>
    );
  }
);

FilePDF.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FilePDF.displayName = 'FilePDF';

export default FilePDF;
